import { scopeCompletionSource } from '@codemirror/lang-javascript';

import './modal-kform-builder-script.scss';
import {
	ThemeExtensions,
	LanguageExtensions,
	Plugins,
	Keymaps,
} from '@knitiv/code-editor';

export default class ModalKformBuilderScriptController {
	/* @ngInject */
	/**
	 * @param {import('angular').translate.ITranslateService} $translate
	 * @param {import('angular').ui.bootstrap.IModalInstanceService} $uibModalInstance
	 * @param {import('~/scripts/services/form.service').default} FormService
	 * @param {any} Notification
	 * @param {any} script
	 */
	constructor(
		$translate,
		$uibModalInstance,
		FormService,
		Notification,
		script,
	) {
		this.$translate = $translate;
		this.$uibModalInstance = $uibModalInstance;
		this.FormService = FormService;
		this.Notification = Notification;
		this.script = script;
	}

	onEditorSetup() {
		return [
			ThemeExtensions.oneLight,
			LanguageExtensions.javascript({ typescript: true }),
			LanguageExtensions.javascriptLanguage.data.of({ autocomplete: scopeCompletionSource(globalThis) }),

			Plugins.FOLD_GUTTERS(),
			Plugins.MATCH_BRACKETS(),
			Plugins.AUTOCOMPLETION(),
			Plugins.CLOSE_BRACKETS(),
			Plugins.DRAW_SELECTION(),
			Plugins.DROP_CURSOR(),
			Plugins.HIGHLIGHT_ACTIVE_LINE_GUTTER(),
			Plugins.HIGHLIGHT_SELECTION_MATCHES(),
			Plugins.HIGHLIGHT_SPECIAL_CHARS(),
			Plugins.HISTORY(),
			Plugins.INDENT_ON_INPUT(),
			Plugins.MULTIPLE_CURSORS(),
			Plugins.RECTANGULAR_SELECTION(),
			Plugins.LINE_NUMBERS(),
			Plugins.KEYMAP.of(Keymaps.KNITIV_KEYMAP),
		];
	}

	verify() {
		const form = this.FormService.create('K_NODE;PERSON');
		try {
			this.FormService.evaluate(this.script, {
				data: {},
				form,
			});
			this.Notification.success({
				title:   this.$translate.instant('common.info'),
				message: this.$translate.instant('common.syntax-ok'),
			});
		}
		catch (/** @type {any} */ error) {
			this.Notification.error({
				title:   this.$translate.instant('error.title'),
				message: error.message,
			});
			console.error(error);
		}
	}

	submit() {
		this.$uibModalInstance.close(this.script);
	}

	cancel() {
		this.$uibModalInstance.dismiss('cancel');
	}
}
